import styled from "@emotion/styled";
import { Body1 } from "@material/react-typography";

// label for both client and project folder info components
export const InfoLabel = styled(Body1)`
  &.mdc-typography--body1 {
    padding: 0 0.5rem;
  }

  span {
    font-weight: bold;
  }

  a {
    border-bottom: 1px solid var(--mdc-theme-primary);
  }
`;
